import React from 'react';

import {
  EntityDependsOnComponentsCard,
  EntityDependsOnResourcesCard,
  EntityLayout,
} from '@backstage/plugin-catalog';

import { Grid } from '@material-ui/core';

import { KaaPTenantOverviewContentCard } from './KaaPTenantOverviewContent';

interface KaaPTenantEntityPageProps {
  ActionContent: React.JSX.Element;
  EntityWarningContent: React.JSX.Element;
}

export const KaaPTenantEntityPage = (props: KaaPTenantEntityPageProps) => {
  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <KaaPTenantOverviewContentCard
          ActionContent={props.ActionContent}
          EntityWarningContent={props.EntityWarningContent}
        />
      </EntityLayout.Route>

      <EntityLayout.Route path="/dependencies" title="Dependencies">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item md={6}>
            <EntityDependsOnComponentsCard />
          </Grid>
          <Grid item md={6}>
            <EntityDependsOnResourcesCard />
          </Grid>
        </Grid>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
